<template>
  <div class="swiper-page-design-popup" v-if="isDesign"></div>
  <!-- <div class="carousel-prewview" @click="isPreviewImage = false" v-if="isPreviewImage"><img :src="isPreviewImage" alt=""></div> -->
  <t-image-viewer v-model="visible" :imageScale="{step: 0.1}"  :images="srcHandler(option.attribute.imgUrls)" :index="currentIndex" @index-change="onIndexChange" :closeOnEscKeydown="true">
    <template #trigger="{ open }">
      <div class="tdesign-demo-image-viewer__ui-image" @click="open">
        <!-- <t-image style="width: 100%;height: 100%;background: none" :src="srcHandler(item)" :fit="option.attribute.fit"
          :error="''"> </t-image> -->
        <div class="swiper-container swiper-page" ref="swiperContainer" :id="refreshFlagKey">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in option.attribute.imgUrls"
              :class="{ 'swiper-slide-active': setSelectedBorder(index) != 'transparent' }"
              :style="{ '--acitveBorderColor': setSelectedBorder(index) }" :key="`slide-${index}`"
              @click="onClickImage(srcHandler(item),index)">
              <!-- <div :style="{ height: height + 'px' }"> -->
              <!-- <t-image style="width: 100%;height: 100%;background: none" :src="srcHandler(item)" :fit="option.attribute.fit"
                  :error="''">
        
                </t-image> -->
              <t-image style="width: 100%;height: 100%;background: none" :src="srcHandler(item)"
                :fit="option.attribute.fit" :error="''"> </t-image>

              <!-- </div> -->
            </div>
          </div>
          <div class="swiper-pagination" v-show="option.attribute.isShowNavbar == '1'">
          </div>
          <div class="swiper-button-prev" @click.stop> </div>
          <div class="swiper-button-next" @click.stop> </div>
        </div>
      </div>
    </template>
  </t-image-viewer>
</template>

<script>
import { fileUrl } from '/env'
import 'swiper/css/swiper.css';
import Swiper from 'swiper'
import { getDataJson, pollingRefresh, hasNonEmptyValues, hasProperty } from "@/utils/refresh-cpt-data";
export default {
  name: "cpt-carousel",

  props: {
    height: { type: Number, default: 168 },
    option: Object, current: Object
  },
  data() {
    return {
      isDesign: false,
      fileUrl,
      refreshFlagKey: '',
      navigation: { type: 'bars', placement: 'outside', showSlideBtn: 'hover' },
      activeIndex: 0,
      newData: '',
      jsFunFlag: false,
      swiperInstance: null,
      visible: false,
      isPreviewImage: false,

      currentIndex: 0,
    }
  },
  computed: {
    setStyles() {
      return {
        "--isShowNavbar": this.option.attribute.isShowNavbar ? 'visible' : 'hidden',
      }
    },
    setSelectedBorder() {
      return index => {
        let newIndex = (index - 1)
        let isActive = this.activeIndex === newIndex
        let borderColor = (this.option.attribute.selecedBorderColor || 'transparent')

        if (isActive && borderColor != 'transparent') {
          return borderColor
        } else {
          return 'transparent'
        }

      }
    },
    srcHandler() {
      return item => {
        if(Array.isArray(item)) {
          console.log(item,'itemitemitemitemitem');
          return item.map(img => {
            return img.includes('http') ? img : (location.origin + '/file' + img)
          })
        } else {
          let url = String(item)
          // console.log(url.includes('http') ? url : (fileUrl + url),fileUrl,'adqqdqwd')
          return url.includes('http') ? url : (location.origin + '/file' + url)
        }
     
      }
    }
  },
  watch: {
    'current.cptWidth': {
      handler(value) {
        this.updateSwiper()
      },
      deep: true
    },
    'current.cptHeight': {
      handler(value) {
        this.updateSwiper()
      },
      deep: true
    },
    'option.attribute.defaultNumber': {
      handler(value) {
        this.updateSwiper()
      },
      deep: true
    },
    'option.attribute.defaultNumber': {
      handler(value) {
        this.updateSwiper()
      },
      deep: true
    },
    'option.attribute.selecedBorderColor': {
      handler(value) {
        this.updateSwiper()
      },
      deep: true
    },
    'option.attribute.isShowNavbar': {
      handler(value) {
        this.updateSwiper()
      },
      deep: true
    },
    'option.attribute.autoPlay': {
      handler(value) {
        this.updateSwiper()
      },
      deep: true
    },

  },
  created() {
    this.isDesign = this.$route.href.includes('/design')
    this.refreshFlagKey = require('uuid').v1();

  },
  mounted() {
    this.refreshCptData(this.option.cptDataForm);

  },
  methods: {
    onClickImage(item,index) {
      console.log(item,index,'itemitemitemitemitemitem');
      this.isPreviewImage = item
      this.currentIndex = index
    },
    initSwiper() {
      const { isShowNavbar } = this.option.attribute
      let option = {
        loop: true,
        width: this.current.cptWidth,
        height: this.current.cptHeight,
        autoplay: this.option.attribute.autoPlay,
        observeParents: true,
        observer: true,
        activeIndex: this.activeIndex,
        initialSlide: this.option.attribute.initialSlide || 0,
        spaceBetween: this.option.attribute.spaceBetween || 1,
        // centeredSlides: true,
        slidesPerView: this.option.attribute.defaultNumber || 1,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: isShowNavbar == '1' ? {
          el: '.swiper-pagination',
          clickable: true, // 分页器可以点击
        } : {},

      }

      // const Swiper = (await import('swiper')).default;

      this.swiperInstance = new Swiper(this.$refs.swiperContainer, option)

    },
    refreshCptData(cptDataForm, paras) {
      pollingRefresh(this.uuid, cptDataForm, () => {
        this.loadData(cptDataForm, paras)
      }, this.components)
    },
    loadData(cptDataForm, paras) {
      const that = this;
      getDataJson(cptDataForm, paras, (res) => {
        that.newData = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
        that.jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因

        that.processData(cptDataForm, that.newData, that.jsFunFlag)
        // console.log(that.jsFunFlag)
      },)
    },
    processData(cptDataForm, res, jsFunFlag, isFromGrid) {
      console.log(res, cptDataForm, 'res');
      // 第一层判断 如果选择数据集
      if (cptDataForm.dataSource == '1') {
        let list = JSON.parse(cptDataForm.dataText)
        if (list.length) {
          this.option.attribute.imgUrls = list
        }
      } else if (cptDataForm.dataSource == '4') {
        if (this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid') return

        // 第二层判断 ，如果没有配转换脚本
        if (jsFunFlag) { // 没有全部配置映射字段
          //判断此控件在九宫格里面就不请求数据
          console.log(hasNonEmptyValues(this.option.attribute.cptTableData), this.option.attribute.cptTableData, 'sdsdssdsd');
          if (hasNonEmptyValues(this.option.attribute.cptTableData)) {

            const dataKey = this.option.attribute.cptTableData;
            // 创建一个新的数组用于存储结果
            let newres = [];
            // 遍历one数组，根据two数组中的映射关系生成新对象并添加到newOptions中
            res.forEach(item => {
              let newItem = {};
              dataKey.forEach(mapping => {
                newItem[mapping.namekey] = item[mapping.value];
              });
              // 合并原有的键值对
              Object.assign(newItem, item);
              newres.push(newItem);
            });

            let newObject = {
              value: [],
              options: newres
            };
            this.newData = newObject;
            if (newObject) {
              this.funselect(newObject);
            }
          }
        } else { // 如果配置了转换脚本
          if (res) {
            this.funselect(res);
          }
        }
      } else { // 不是数据集类型，是静态数据
        if (res)
          this.funselect(res);
      }

      this.initSwiper()

    },
    funselect(res) {
      console.log(res, this.option.attribute.imgUrls, 're我的钱多群群多s');
      if (!res || !res?.options || res?.options?.length === 0) {
        return
      }
      console.log(res, 'resres.listres.list');
      let list = res.options.map(item => item.value).filter(x => x)
      // if (list.length == 0) {
      //   this.option.attribute.imgUrls = list
      //   return
      // }

      console.log(list, 'qwdqdqwd');
      this.option.attribute.imgUrls = list





    },
    updateSwiper() {
      let designPage = location.href.includes('/design')
      if (!designPage) {
        return
      }
      this.swiperInstance.destroy(true, true)
      this.initSwiper()
    },
    onSwiper() {
      console.log('123');
    },
    onBeforeUnmount() {
      this.swiperInstance.destroy()
    },
    open(e) {
      console.log(e,'qwdkoimjqwdqiojwdijowqd');
    },
    onIndexChange(i) {
      this.currentIndex = i
    }
  }
}
</script>

<style scoped>
.t-swiper /deep/ .t-swiper__navigation {
  visibility: var(--isShowNavbar);
}

.swiper-page {
  width: 100%;
  height: 100%;
}

.swiper-page .swiper-slide {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.swiper-page .swiper-slide /deep/ .t-image__loading {
  opacity: 0;
}

/* 做不了边框  使用伪元素覆盖做 */

.swiper-page-design-popup {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  z-index: 1000000;
}

.swiper-page .swiper-slide-active {
  position: relative;
}

.swiper-page .swiper-slide-active::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* border: 1px solid var(--acitveBorderColor); */
  border: 2px solid var(--acitveBorderColor);
  z-index: 1;
}

.swiper-page .swiper-button-prev,
.swiper-page .swiper-button-next {
  position: absolute;
  top: calc(50% + (var(--swiper-navigation-size) / 2));
  transform: translateY(-50%);
  left: 5px;
  z-index: 9;
}

.swiper-page .swiper-button-prev::after,
.swiper-page .swiper-button-next::after {
  font-size: 12px !important;
  color: #fff;
}

.swiper-page .swiper-button-prev:hover,
.swiper-page .swiper-button-next:hover {
  background: rgba(255, 255, 255, 0.55);
  transition: background .4s ease-in-out;
}

.swiper-page .swiper-button-prev:hover::after,
.swiper-page .swiper-button-next:hover::after {
  color: #000;
}


.swiper-page .swiper-button-next {
  left: unset !important;
  right: 5px;
}


.swiper-page .swiper-pagination {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;

}

.swiper-page /deep/ .swiper-pagination-bullet {
  width: 14px !important;
  height: 3px !important;
  background: rgba(255, 255, 255, .9);
  margin-right: 3px;
  cursor: pointer;
  border-radius: unset;
}

.swiper-page /deep/ .swiper-pagination-bullet-active {
  background: #000 !important;
  width: 20px !important;
}

/* 
#swipercom {
  width: 7.5rem;



}

#swipercom #swiperIndex.swiper-container {
  width: 7.1rem;
  height: 2.6rem;
  border-radius: 0.1rem;


} */

.carousel-prewview {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 100000000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-prewview img {
  max-width: 100%;
  max-height: 100%;
}
</style>


<style>
.tdesign-demo-image-viewer__ui-image {
  width: 160px;
  height: 160px;
  display: inline-flex;
  position: relative;
  justify-content: center;
  align-items: center;
  border-radius: var(--td-radius-small);
  overflow: hidden;
  z-index: 999;
}

.tdesign-demo-image-viewer__ui-image--hover {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  background-color: rgba(0, 0, 0, 0.6);
  color: var(--td-text-color-anti);
  line-height: 22px;
  transition: 0.2s;
}

.tdesign-demo-image-viewer__ui-image:hover .tdesign-demo-image-viewer__ui-image--hover {
  opacity: 1;
  cursor: pointer;
}

.tdesign-demo-image-viewer__ui-image--img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  cursor: pointer;
  position: absolute;
}

.tdesign-demo-image-viewer__ui-image--footer {
  padding: 0 16px;
  height: 56px;
  width: 100%;
  line-height: 56px;
  font-size: 16px;
  position: absolute;
  bottom: 0;
  color: var(--td-text-color-anti);
  background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%);
  display: flex;
  box-sizing: border-box;
}

.tdesign-demo-image-viewer__ui-image--title {
  flex: 1;
}

.tdesign-demo-popup__reference {
  margin-left: 16px;
}

.tdesign-demo-image-viewer__ui-image--icons .tdesign-demo-icon {
  cursor: pointer;
}

.tdesign-demo-image-viewer__base {
  width: 160px;
  height: 160px;
  margin: 10px;
  border: 4px solid var(--td-bg-color-secondarycontainer);
  border-radius: var(--td-radius-medium);
}

.t-image-viewer-preview-image .t-image-viewer__modal-pic .t-image-viewer__modal-box .t-image-viewer__modal-image {
  max-width: min(80vw, 1000px) !important;
  max-height: min(80vw, 700px) !important;
}
</style>
